import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Alert, Button, DialogActions, DialogContent, DialogTitle,
  Divider, IconButton, Stack, Typography,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import AppDialog from '../../../shared/components/AppDialog';
import { humanize } from '../../../shared/utils/text';

export default function OperationDialog({ value, onClose }) {
  const { t } = useTranslation();
  const [retainedValue, setRetainedValue] = useState(value);
  useEffect(() => {
    if (value) setRetainedValue(value);
  }, [value]);
  const displayValue = value || retainedValue;
  const counters = Object.entries(displayValue?.counters || {})
    .filter(([, count]) => Number.isFinite(Number(count)));

  return (
    <AppDialog
      open={Boolean(value)}
      onClose={onClose}
      TransitionProps={{ onExited: () => setRetainedValue(null) }}
      maxWidth="sm"
      fullWidth
      sx={{ '& .MuiButton-root': { borderRadius: '6px' } }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        {t('dataInput.operation.title')}
        <IconButton
          onClick={onClose}
          aria-label={t('common.close')}
          sx={{ position: 'absolute', right: 12, top: 12 }}
        >
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Alert severity={displayValue?.severity || 'info'}>
            {displayValue?.message}
          </Alert>
          {counters.length > 0 && (
            <Stack divider={<Divider flexItem />}>
              {counters.map(([key, count]) => (
                <Stack key={key} direction="row" justifyContent="space-between" spacing={2} sx={{ py: 0.75 }}>
                  <Typography variant="body2" color="text.secondary">
                    {t(`dataInput.counter.${key}`, { defaultValue: humanize(key) })}
                  </Typography>
                  <Typography variant="body2" fontWeight={700}>{Number(count).toLocaleString()}</Typography>
                </Stack>
              ))}
            </Stack>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: 1.5 }}>
        <Button onClick={onClose}>{t('common.close')}</Button>
      </DialogActions>
    </AppDialog>
  );
}
